"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _webexCore = require("@webex/webex-core");
var _constants = require("../constants");
var _parameter = _interopRequireDefault(require("../common/errors/parameter"));
var _util = _interopRequireDefault(require("./util"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @class MembersRequest
 */
var MembersRequest = /*#__PURE__*/function (_StatelessWebexPlugin) {
  (0, _inherits2.default)(MembersRequest, _StatelessWebexPlugin);
  var _super = _createSuper(MembersRequest);
  function MembersRequest() {
    var _this;
    (0, _classCallCheck2.default)(this, MembersRequest);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "namespace", _constants.MEETINGS);
    return _this;
  }
  (0, _createClass2.default)(MembersRequest, [{
    key: "addMembers",
    value:
    /**
     *
     * @param {Object} options with format of {invitee: string, locusUrl: string}
     * @returns {Promise}
     * @throws {Error} if the options are not valid and complete, must have invitee with emailAddress OR email AND locusUrl
     * @memberof MembersRequest
     */
    function addMembers(options) {
      if (!(!options || !options.invitee || !options.invitee.emailAddress || !options.invitee.email || !options.invitee.phoneNumber || !options.locusUrl)) {
        throw new _parameter.default('invitee must be passed and the associated locus url for this meeting object must be defined.');
      }
      var requestParams = _util.default.getAddMemberRequestParams(options);

      // @ts-ignore
      return this.request(requestParams);
    }

    /**
     *
     * @param {Object} options
     * @returns {Promise}
     * @throws {Error} if the options are not valid and complete, must have memberIds AND locusUrl
     * @memberof MembersRequest
     */
  }, {
    key: "admitMember",
    value: function admitMember(options) {
      if (!options || !options.locusUrl || !options.memberIds) {
        throw new _parameter.default('memberIds must be an array passed and the associated locus url for this meeting object must be defined.');
      }
      var requestParams = _util.default.getAdmitMemberRequestParams(options);

      // @ts-ignore
      return this.request(requestParams);
    }
  }, {
    key: "removeMember",
    value: function removeMember(options) {
      if (!options || !options.locusUrl || !options.memberId) {
        throw new _parameter.default('memberId must be defined, and the associated locus url for this meeting object must be defined.');
      }
      var requestParams = _util.default.getRemoveMemberRequestParams(options);

      // @ts-ignore
      return this.request(requestParams);
    }
  }, {
    key: "muteMember",
    value: function muteMember(options) {
      if (!options || !options.locusUrl || !options.memberId) {
        throw new _parameter.default('memberId must be defined, and the associated locus url for this meeting object must be defined.');
      }
      var requestParams = _util.default.getMuteMemberRequestParams(options);

      // @ts-ignore
      return this.request(requestParams);
    }
  }, {
    key: "raiseOrLowerHandMember",
    value: function raiseOrLowerHandMember(options) {
      if (!options || !options.locusUrl || !options.memberId) {
        throw new _parameter.default('memberId must be defined, and the associated locus url for this meeting object must be defined.');
      }
      var requestParams = _util.default.getRaiseHandMemberRequestParams(options);

      // @ts-ignore
      return this.request(requestParams);
    }
  }, {
    key: "lowerAllHandsMember",
    value: function lowerAllHandsMember(options) {
      if (!options || !options.locusUrl || !options.requestingParticipantId) {
        throw new _parameter.default('requestingParticipantId must be defined, and the associated locus url for this meeting object must be defined.');
      }
      var requestParams = _util.default.getLowerAllHandsMemberRequestParams(options);

      // @ts-ignore
      return this.request(requestParams);
    }
  }, {
    key: "transferHostToMember",
    value: function transferHostToMember(options) {
      if (!options || !options.locusUrl || !options.memberId || !options.moderator) {
        throw new _parameter.default('memberId must be defined, the associated locus url, and the moderator for this meeting object must be defined.');
      }
      var requestParams = _util.default.getTransferHostToMemberRequestParams(options);

      // @ts-ignore
      return this.request(requestParams);
    }

    /**
     * Sends a request to the DTMF endpoint to send tones
     * @param {Object} options
     * @param {String} options.locusUrl
     * @param {String} options.url device url SIP user
     * @param {String} options.tones a string of one or more DTMF tones to send
     * @param {String} options.memberId ID of PSTN user
     * @returns {Promise}
     */
  }, {
    key: "sendDialPadKey",
    value: function sendDialPadKey(options) {
      // @ts-ignore
      if (!options || !options.locusUrl || !options.memberId || !options.url ||
      // @ts-ignore
      !options.tones && options.tones !== 0) {
        throw new _parameter.default('memberId must be defined, the associated locus url, the device url and DTMF tones for this meeting object must be defined.');
      }
      var requestParams = _util.default.generateSendDTMFRequestParams(options);

      // @ts-ignore
      return this.request(requestParams);
    }

    /**
     * @param {Object} options with format of {invitee: string, locusUrl: string}
     * @returns {Promise}
     * @throws {Error} if the options are not valid and complete, must have invitee with emailAddress OR email AND locusUrl
     * @memberof MembersRequest
     */
  }, {
    key: "cancelPhoneInvite",
    value: function cancelPhoneInvite(options) {
      var _options$invitee;
      if (!(options !== null && options !== void 0 && (_options$invitee = options.invitee) !== null && _options$invitee !== void 0 && _options$invitee.phoneNumber || options !== null && options !== void 0 && options.locusUrl)) {
        throw new _parameter.default('invitee must be passed and the associated locus url for this meeting object must be defined.');
      }
      var requestParams = _util.default.generateCancelInviteRequestParams(options);

      // @ts-ignore
      return this.request(requestParams);
    }
  }]);
  return MembersRequest;
}(_webexCore.StatelessWebexPlugin);
exports.default = MembersRequest;
//# sourceMappingURL=request.js.map
